import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../../../shared/shared.module';
import { ServicesAndPricingFormComponent } from './services-and-pricing.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PayeeSelectionModule } from '../../../../../../shared/payouts/payee-selection/payee-selection.module';
import { AddEditVesselRateDialogModule } from './add-edit-vessel-rate-dialog/add-edit-vessel-rate-dialog.module';
import { ListGridModule } from '../../../../../../shared/listGrid/listGrid.module';
import { AgGridModule } from 'ag-grid-angular';
import { NameEditButtonComponent } from './line-item-actions/nameEditButton/nameEditButton.component';
import { DeleteButtonComponent } from './line-item-actions/deleteButton/deleteButton.component';
import { CustomPriceComponent } from './line-item-actions/customPrice/customPrice.component';
import { hasSplitsButtonComponent } from './line-item-actions/hasSplitsButton/nameEditButton.component';
import { AddEditVesselRatePerHourDialogModule } from './add-edit-vessel-rate-per-hour-dialog/add-edit-vessel-rate-per-hour-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    MatDialogModule,
    MatTabsModule,
    MatSliderModule,
    MatCheckboxModule,
    MatRadioModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    PayeeSelectionModule,
    AddEditVesselRateDialogModule,
    AddEditVesselRatePerHourDialogModule,
    ListGridModule,
    AgGridModule.withComponents([
      NameEditButtonComponent,
      hasSplitsButtonComponent,
      DeleteButtonComponent,
      CustomPriceComponent,
    ]),
  ],
  declarations: [ServicesAndPricingFormComponent],
  entryComponents: [],
  exports: [ServicesAndPricingFormComponent],
  providers: [],
})
export class ServicesAndPricingFormModule {}
